// import './js';
import React from 'react';
import ReactDOM from 'react-dom';
import components from './components';
import './styles'
import 'intersection-observer';
import $ from 'jquery';

import exchangerateBlock from './exchange-rate-block';
import faqListingBlock from './faq-listing-block';
import accordionToggle from './accordion-toggle';
import lazyLoad from './lazy-load';
import { toggleMenu, handleMenuItemClick, toggleChildren } from './menu';
import Youtube from './youtube';

window.React = React;
window.ReactDOM = ReactDOM;
window.Components = components;

document.addEventListener('DOMContentLoaded', function() {
    const scrollbarWidth = (window.innerWidth - document.body.clientWidth);
    $('body').css('--scrollbarWidth', `-${scrollbarWidth}px`);

    exchangerateBlock();
    faqListingBlock();
    accordionToggle();
    toggleMenu();
    handleMenuItemClick();
    toggleChildren();
    Youtube();
    initSearchResultYearFilter();
    initArchiveYearFilter();

    // images
    lazyLoad('img[data-lazy]');
    // backgrounds
    lazyLoad('div[data-lazy]');

    // Add cookie settings link to footer and menu
    const cookieHandle = `<a href="javascript:CookieScript.instance.show()" class="footer__link">Cookieinställningar</a>`;
    $('.footer__column:nth-child(2) .footer__links').append(cookieHandle);
    const menuItem = `<li class="menu__item menu__item--mobile"><a href="javascript:CookieScript.instance.show()" class="menu__link">Cookieinställningar</a></li>`;
    $('.js-menu').append(menuItem);
});

const initSearchResultYearFilter = () => {
    const yearFilter = $('.js-search-result-year-filter');

    yearFilter.change(function() {
        let form = $(this).closest('form');
        form.submit();
    });
}

const initArchiveYearFilter = () => {
    $('#archive-filter').on('change', function() {
        window.location.href = $(this).val();
    })
}
